module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.error
    }
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(99)9999[9]-9999'),
      expression: "'(99)9999[9]-9999'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": _vm.name,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "help-block",
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74bc8434!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/inputs/InputPhone.vue
// module id = 357
// module chunks = 12